import { Text } from '@react-three/drei'
import { useAppStore } from '@store'
import { Walls } from '@types'
import { calcRotation } from '@utils/generalMaths/calcRotation'
import is2DMode from '@utils/is2DMode'
import { getInnerAngle } from '@utils/sceneObjects/walls/getInnerAngle'

type Props = { id: string; offset: number }

export default function WallDimentions({ id, offset }: Props) {
  const VERTICAL_WALL_ARGS = [8, 100] satisfies [
    width?: number | undefined,
    height?: number | undefined,
    depth?: number | undefined,
    widthSegments?: number | undefined,
    heightSegments?: number | undefined,
    depthSegments?: number | undefined,
  ]
  const item = useAppStore((store) => store.items.get(id)!) as Walls
  const width = item.width
  const start = item.start
  const end = item.end
  const rotation = item.rotation
  const unit = useAppStore((store) => store.prefs?.UNIDADMEDIDA)
  const PREFS_COLOR_COTA = useAppStore((store) => store.prefs?.['C/LINEASCOTA'])
  const HORIZONTAL_WALL_ARGS = [width, 7] satisfies [
    width?: number | undefined,
    height?: number | undefined,
    depth?: number | undefined,
    widthSegments?: number | undefined,
    heightSegments?: number | undefined,
    depthSegments?: number | undefined,
  ]
  const prevWall = item.prevWall
  const prevWallObject = useAppStore.use.items().get(prevWall) as Walls
  const { cp } = getInnerAngle(start, end, prevWallObject?.start, prevWallObject?.end)
  const thickness = item.thickness
  const PREFS_COLOR_TEXTO = useAppStore((store) => store.prefs?.['C/COTA'])
  const FONT_SIZE = useAppStore.use.prefs()?.['T/LETRACOTA'] ?? 100
  const neededRotation = calcRotation(cp, rotation)
  const pref = useAppStore.use.prefs()?.['VERUNIDADESENCOTAS']
  const mode = useAppStore.use.mode()
  const is2dmode = is2DMode(mode)
  const offsets = is2dmode ? -thickness - offset : thickness + 100
  return (
    <group>
      <mesh
        rotation={[-Math.PI / 2, 0, 0]}
        position={[-width / 2, 2, offsets]}
      >
        <boxGeometry args={VERTICAL_WALL_ARGS} />
        <meshBasicMaterial color={PREFS_COLOR_COTA} />
      </mesh>
      <mesh
        position={[0, 2, offsets]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <boxGeometry args={HORIZONTAL_WALL_ARGS} />
        <meshBasicMaterial color={PREFS_COLOR_COTA} />
        <Text
          position={[0, 75, 0]}
          fontSize={FONT_SIZE}
          characters='abcdefghijklmnopqrstuvwxyz0123456789!ºª'
          color={PREFS_COLOR_TEXTO}
          rotation={[0, ...neededRotation]}
        >
          {`${Math.trunc(width)} ${pref ? unit : ''}`}
        </Text>
      </mesh>
      <mesh
        rotation={[-Math.PI / 2, 0, 0]}
        position={[width / 2, 2, offsets]}
      >
        <boxGeometry args={VERTICAL_WALL_ARGS} />
        <meshBasicMaterial color={PREFS_COLOR_COTA} />
      </mesh>
    </group>
  )
}
